<template>
  <div :id="id" :style="{width, height}"></div>
</template>

<script>
import barChart from './bar';

export default {
  name: 'BarChart',
  props: {
    id: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: '100%',
    },
    width: {
      type: String,
      default: '100%',
    },
    xData: {
      type: Array,
      default() {
        return [];
      },
      deep: true,
    },
    yData: {
      type: Array,
      default() {
        return [];
      },
      deep: true,
    },
    xRotate: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    xData(val) {
      if (val) {
        this.setChart();
      }
    },
    yData(val) {
      if (val) {
        this.setChart();
      }
    },
  },
  data() {
    return {
      data: [],
    };
  },
  methods: {
    setChart() {
      barChart(this.id || 'chart-main', {
        title: '',
        xData: this.xData,
        toolbox: {
          show: false,
        },
        tooltipFormatter(params) {
          let result = '';
          for (let i = 0, length = params.length; i < length; i++) {
            const itemColor = params[i].color;
            result += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background:${itemColor}"></span>`;
            result += `${params[i].seriesName}: ${params[i].value} 万元<br />`;
          }
          return result;
        },
        yAxis: {
          title: '金额(万元)',
        },
        xAxis: {
          rotate: this.xRotate,
        },
        yData: this.yData,
      });
    },
  },
  created() {
    console.log('id: ', this.id);
  },
  mounted() {
    this.setChart();
  },
};
</script>

<style scoped>

</style>
